import SearchAutoSelectRuleName from './SearchAutoSelectRuleName';

export default SearchAutoSelectRuleName;
